export default {
  dark: {
    baseHoverColor: '#00d697',

    modalCloseIconColor: 'rgba(255, 255, 255, 0.5)',

    iconBaseColor: '#333B50',
    iconOutlineColor: '#ffffff',
    iconSublineColor: '#5B88DE',
    iconPositiveColor: '#00d697',
    iconNegativeColor: '#FF4CF8',

    layoutTextColor: 'rgba(255, 255, 255, 0.7)',

    headerProjectTitleColor: '#fff',
    headerServiceTitleColor: '#fff',

    cartBackgroundColor: '#333b50',
    cartBoxShadowColor: 'rgba(51, 59, 80, 0.8)',
    cartOldPriceColor: 'rgba(255, 255, 255, 0.3)',
    cartTextColor: 'rgba(255, 255, 255, 0.7)',
    cartPriceColor: '#ffffff',
    cartStrokeColor: 'rgba(153, 157, 167, 0.2)',
    cartAccentColor: '#06eaa7',
    cartTotalNoticeColor: 'rgba(255, 255, 255, 0.5)',
    cartIconsColor: 'rgba(255, 255, 255, 0.3)',
    cartSelectedBackgroundColor: '#514F59',
    cartSelectedIconsColor: '#fff',

    formBackgroundColor: '#514F59',
    formLabelColor: 'rgba(255, 255, 255, 0.5)',

    savedCardsBackgroundColor: '#525f80',
    savedCardsTextColor: '#fff',
    savedCardsSelectedBackgroundColor: '#fff',
    savedCardsSelectedTextColor: '#32394D',
    savedCardsSwitchColor: '#05D699',
    savedCardsCheckIconColor: '#05D699',
    savedCardsDeleteBackgroundColor: '#7A5B62',
    savedCardsDeleteTextColor: '#fc7e57',
    savedCardsDeleteIconColor: '#b3b7c2',

    localeChangerModalBorderColor: 'rgba(255, 255, 255, 0.2)',
    localeChangerModalBoxColor: '#333b50',
    localeChangerModalColor: 'rgba(255, 255, 255, 0.7)',
    localeChangerModalCurrentColor: '#06eaa7',
    localeChangerModalHoverBorderColor: 'rgba(255, 255, 255, 0.5)',

    localeChangerPageBorderColor: 'rgba(255, 255, 255, 0.2)',
    localeChangerPageBoxColor: '#333b50',
    localeChangerPageColor: 'rgba(255, 255, 255, 0.7)',
    localeChangerPageCurrentColor: '#06eaa7',
    localeChangerPageHoverBorderColor: 'rgba(255, 255, 255, 0.5)',
    localeChangerPageHoverColor: '#06eaa7',

    buttonAlign: 'center',
    buttonColor: '#fff',
    buttonBoxColor: '#5b88de',
    buttonActiveBoxColor: '#4e7fdb',
    buttonHoverBoxColor: '#6891e1',
    buttonDisabledOpacity: '0.7',
    buttonBeforeColor: '#fff',
    buttonAfterColor: '#fff',

    checkboxColor: '#fff',
    checkboxIconColor: '#fff',
    checkboxHoverColor: '#06eaa7',
    checkboxHoverIconColor: '#06eaa7',
    checkboxCheckedColor: '#fff',
    checkboxCheckedIconColor: '#06eaa7',
    checkboxDisabledOpacity: '0.7',

    preloaderColor: 'rgba(255, 255, 255, 0.1)',
    preloaderSpinColor: '#06eaa7',

    inputBorderColor: 'rgba(255, 255, 255, 0.2)',
    inputBoxColor: 'transparent',
    inputColor: '#fff',
    inputDisabledOpacity: '0.5',
    inputFocusBorderColor: '#06eaa7',
    inputFocusLabelColor: 'rgba(255, 255, 255, 0.3)',
    inputHoverBorderColor: 'rgba(255, 255, 255, 0.5)',

    selectBorderColor: 'rgba(255, 255, 255, 0.2)',
    selectBoxColor: 'transparent',
    selectColor: '#fff',
    selectPlaceholderColor: 'rgba(255, 255, 255, 0.5)',
    selectDisabledOpacity: '0.5',
    selectFocusBorderColor: '#06eaa7',
    selectHoverBorderColor: 'rgba(255, 255, 255, 0.5)',
    selectOptionsBoxColor: '#514F59',
    selectRemoveColor: '#fc7e57',

    errorBorderColor: '#fc7e57',
    errorBoxColor: '#fc7e57',
    errorColor: '#fff',

    tipCartBoxColor: '#514F59',
    tipContentColor: 'rgba(255, 255, 255, 0.5)',
    tipFormBoxColor: '#333B50',
    tipLinkColor: '#fff',

    iconInfoColor: 'rgba(255, 255, 255, 0.3)',
    iconInfoHoverColor: '#06eaa7',

    stubContentColorPrimary: 'rgba(255, 255, 255, 0.2)',
    stubSpinContentColorPrimary: 'rgba(255, 255, 255, 0.15)',
    stubContentColorSecondary: 'rgba(255, 255, 255, 0.1)',
    stubSpinContentColorSecondary: 'rgba(255, 255, 255, 0.1)',
    stubTotalColor: 'rgba(6, 234, 167, 0.3)',
    stubSpinTotalColor: 'rgba(6, 234, 167, 0.2)',

    warningTitleColor: '#ffffff',
    warningTextColor: '#f3da58',

    processTitleColor: '#ffffff',
    processTextColor: '#ffffff',

    resultTitleColor: '#ffffff',
    resultSubtitleColor: '#ffffff',
    resultTextColor: '#ffffff',
    resultSubtextColor: '#b3b3b3',
    resultCodeColor: '#06eaa7',
    resultEmailColor: '#ffffff',

    scrollbarColor: 'rgba(0, 0, 0, 0.7)',
  },
  light: {
    baseHoverColor: '#06eaa7',

    modalCloseIconColor: '#202226',

    iconBaseColor: '#5B88DE',
    iconOutlineColor: '#202226',
    iconSublineColor: '#00d697',
    iconPositiveColor: '#00d697',
    iconNegativeColor: '#FF4CF8',

    layoutTextColor: '#71757a',

    headerProjectTitleColor: '#202226',
    headerServiceTitleColor: '#5b88de',

    cartBackgroundColor: '#f3f3f3',
    cartBoxShadowColor: 'rgba(243, 243, 243, 0.8)',
    cartOldPriceColor: 'rgba(194, 194, 196, 0.3)',
    cartTextColor: '#71757a',
    cartPriceColor: '#000000',
    cartStrokeColor: 'rgba(194, 194, 196, 0.3)',
    cartAccentColor: '#202226',
    cartTotalNoticeColor: 'rgba(32, 34, 38, 0.4)',
    cartIconsColor: 'rgba(0, 0, 0, 0.3)',
    cartSelectedBackgroundColor: '#e2e2e2',
    cartSelectedIconsColor: '#202226',

    formBackgroundColor: '#fff',
    formLabelColor: 'rgba(32, 34, 38, 0.4)',

    savedCardsBackgroundColor: '#f3f3f3',
    savedCardsTextColor: '#202226',
    savedCardsSelectedBackgroundColor: '#5b88de',
    savedCardsSelectedTextColor: '#fff',
    savedCardsSwitchColor: '#05D699',
    savedCardsCheckIconColor: '#fff',
    savedCardsDeleteBackgroundColor: '#f1dee2',
    savedCardsDeleteTextColor: '#ca5833',
    savedCardsDeleteIconColor: '#c3c3c3',

    localeChangerModalBorderColor: 'rgba(194, 194, 196, 0.5)',
    localeChangerModalBoxColor: '#f3f3f3',
    localeChangerModalColor: '#202226',
    localeChangerModalCurrentColor: '#06eaa7',
    localeChangerModalHoverBorderColor: 'rgba(194, 194, 196, 0.8)',

    localeChangerPageBorderColor: 'rgba(255, 255, 255, 0.2)',
    localeChangerPageBoxColor: '#5b88de',
    localeChangerPageColor: '#fff',
    localeChangerPageCurrentColor: '#06eaa7',
    localeChangerPageHoverBorderColor: 'rgba(255, 255, 255, 0.5)',
    localeChangerPageHoverColor: '#06eaa7',

    buttonAlign: 'center',
    buttonColor: '#fff',
    buttonBoxColor: '#5b88de',
    buttonActiveBoxColor: '#4e7fdb',
    buttonHoverBoxColor: '#6891e1',
    buttonDisabledOpacity: '0.7',
    buttonBeforeColor: '#fff',
    buttonAfterColor: '#fff',

    checkboxColor: '#202226',
    checkboxIconColor: '#202226',
    checkboxHoverColor: '#06eaa7',
    checkboxHoverIconColor: '#06eaa7',
    checkboxCheckedColor: '#202226',
    checkboxCheckedIconColor: '#06eaa7',
    checkboxDisabledOpacity: '0.7',

    preloaderColor: 'rgba(255, 255, 255, 0.1)',
    preloaderSpinColor: '#06eaa7',

    inputBorderColor: 'rgba(194, 194, 196, 0.5)',
    inputBoxColor: 'transparent',
    inputColor: '#202226',
    inputDisabledOpacity: '0.5',
    inputFocusBorderColor: '#06eaa7',
    inputFocusLabelColor: 'rgba(0, 0, 0, 0.3)',
    inputHoverBorderColor: 'rgba(194, 194, 196, 0.8)',

    selectBorderColor: 'rgba(194, 194, 196, 0.5)',
    selectBoxColor: 'transparent',
    selectColor: '#202226',
    selectPlaceholderColor: 'rgba(32, 34, 38, 0.5)',
    selectDisabledOpacity: '0.5',
    selectFocusBorderColor: '#06eaa7',
    selectHoverBorderColor: 'rgba(194, 194, 196, 0.8)',
    selectOptionsBoxColor: '#fff',
    selectRemoveColor: '#fc7e57',

    errorBorderColor: '#fc7e57',
    errorBoxColor: '#fc7e57',
    errorColor: '#fff',

    tipCartBoxColor: '#5b88de',
    tipContentColor: 'rgba(255, 255, 255, 0.5)',
    tipFormBoxColor: '#5b88de',
    tipLinkColor: '#fff',

    iconInfoColor: 'rgba(113, 117, 122, 0.3)',
    iconInfoHoverColor: '#06eaa7',

    stubContentColorPrimary: 'rgba(0, 0, 0, 0.2)',
    stubSpinContentColorPrimary: 'rgba(0, 0, 0, 0.15)',
    stubContentColorSecondary: 'rgba(0, 0, 0, 0.1)',
    stubSpinContentColorSecondary: 'rgba(0, 0, 0, 0.1)',
    stubTotalColor: 'rgba(6, 234, 167, 0.2)',
    stubSpinTotalColor: 'rgba(6, 234, 167, 0.2)',

    warningTitleColor: '#202226',
    warningTextColor: '#71757a',

    processTitleColor: '#202226',
    processTextColor: '#202226',

    resultTitleColor: '#202226',
    resultSubtitleColor: '#202226',
    resultTextColor: '#202226',
    resultSubtextColor: '#202226',
    resultCodeColor: '#202226',
    resultEmailColor: '#202226',

    scrollbarColor: 'rgba(0, 0, 0, 0.7)',
  },
};
